export default __webpack_public_path__ + "static/media/default-avatar.f7b685ef.svg";